function returnFalse() {
  return false;
}

export { returnFalse as default };
